import { instBundle } from '@/axios.js';
import _ from 'lodash';
import Util from '@/util';
import { formattedDate } from '../../util';

const axiosAdmin2 = instBundle.axiosAdmin2;

export default {
	namespaced: true,
	state: {
		storeList: [],
		lastParams: {},
		selectedBrand: null,
	},
	getters: {},
	mutations: {
		changeState(state, list) {
			list.forEach(item => {
				state[item.key] = item.value;
			});
		},
		setLastParams(state, params) {
			state.lastParams = params;
		},
		setSelectedBrand(state, brand) {
			state.selectedBrand = brand;
		},
	},
	actions: {
		async downExcel({ state, commit }, { params, totalItem }) {
			try {
				commit('setLastParams', params);
				const queryString = new URLSearchParams(
					Object.entries(state.lastParams).filter(
						([key, value]) => value !== null
					)
				).toString();
				const url = `/api/brands/list/excel?${queryString}`;
				const title = `브랜드검색(${params.offset + 1}~${params.limit + params.offset > totalItem ? totalItem : params.limit})`;

				const { data, config } = await axiosAdmin2.get(url);
				const rows = data.map(item => [
					item.idBrand,
					item.name,
					item.subName,
					item.country,
					item.brandCategoryText,
					formattedDate(item.createDate),
					item.isDisplay ? 'Y' : 'N',
					item.productCount,
					item.readCount,
					item.reviewCount,
					item.wishCount,
					item.ratingAvg,
					item.evaluationCount,
				]);
				Util.getCsv(
					[rows],
					[title],
					[
						[
							'id',
							'브랜드명',
							'브랜드명(보조)',
							'국가',
							'카테고리',
							'등록일',
							'전시여부',
							'제품수',
							'조회수',
							'리뷰수',
							'위시수',
							'전제품 평균평점',
							'평가단 리뷰수',
						],
					],
					`글로우픽_${title}`,
					config.url
				);
			} catch (err) {
				console.error(err);
				alert('엑셀 다운로드에 실패했습니다. 개발팀에 문의하세요.');
			}
		},
		async getStoreList({ state }) {
			try {
				const { data } = await axiosAdmin2.get(
					'/api/brands/brandTypeList'
				);
				state.storeList = data.data.map(item => {
					return {
						id: item.idBrandType,
						name: `${item.isDisplay === 'N' ? '[비전시]' : ''}${item.brandTypeName}`,
					};
				});
			} catch (err) {
				alert(
					'스토어 리스트 불러오기에 실패했습니다. 개발팀에 문의하세요.'
				);
			}
		},
	},
};
